import estimate from "@nextories/vue-core-components/src/i18n/langs/fr/estimate";

export default {
  ...estimate,
  additionalCost: {
    label: "Total : {price}",
    uprightPiano: "Piano droit",
    grandPiano: "Piano à queue",
    americanFridge: "Frigidaire américain",
    secondAddress: "2ème adresse",
    portageSup: "Portage > 50 m",
    scooter: "Scooter / Moto",
    total: 'Total',
  },
  formula: {
    ...estimate.formula,
    verylow_estimate: {
      id: "verylow_estimate",
      initInfo: true,
      description: [
        "Protection du mobilier et literie",
        "Transport et remise en place de vos biens",
      ],
    },
    low_estimate: {
      id: "low_estimate",
      initInfo: true,
      description: [
        "FORMULE TRANSPORT",
        "Fourniture de cartons",
        "Démontage et remontage du mobilier",
      ],
    },
  },
};
